import { CommonPlayerEventParams } from '../useCommonPlayerEventParams';
import { useTriggerOnPlayerEvent } from '../useTriggerOnPlayerEvent';

export const useTriggerOnPlaybackStop = (params: CommonPlayerEventParams) => {
    return useTriggerOnPlayerEvent(params, 'PLAYBACK_STOP');
};
